module.exports = __webpack_public_path__ + "static/media/kendall.5289a5c6.png";